var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8175 20.0526C6.65876 20.0526 2.47601 15.9436 2.47601 10.8669C2.47601 5.7902 6.65876 1.67306 11.8175 1.67306C16.9762 1.67306 21.159 5.7902 21.159 10.8669C21.159 15.9436 16.9762 20.0526 11.8175 20.0526ZM26.7671 24.8094L19.9935 18.1416C21.7675 16.2143 22.8567 13.6718 22.8567 10.8669C22.8567 4.86347 17.9145 0 11.8175 0C5.72052 0 0.77832 4.86347 0.77832 10.8669C0.77832 16.8622 5.72052 21.7257 11.8175 21.7257C14.4518 21.7257 16.868 20.8153 18.7658 19.298L25.5673 25.9904C25.8986 26.3185 26.4358 26.3185 26.7671 25.9904C27.0993 25.6706 27.0993 25.1375 26.7671 24.8094ZM15.9667 10.178H12.6885V6.89739C12.6885 6.43811 12.3219 6.07725 11.8692 6.07725C11.4173 6.07725 11.0499 6.43811 11.0499 6.89739V10.178H7.77341C7.3215 10.178 6.95408 10.3256 6.95408 10.7767C6.95408 11.236 7.3215 11.8183 7.77341 11.8183H11.0499V15.0989C11.0499 15.5581 11.4173 15.919 11.8692 15.919C12.3219 15.919 12.6885 15.5581 12.6885 15.0989V11.8183H15.9667C16.4186 11.8183 16.786 11.4492 16.786 10.9981C16.786 10.547 16.4186 10.178 15.9667 10.178Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInIcon);
export default __webpack_public_path__ + "static/media/zoomInIcon.46e6aaf5706c8e173cabfc53ba1c6dcf.svg";
export { ForwardRef as ReactComponent };